import * as React from 'react'
import {
  DescriptionText,
  MainTitleText,
  PropInline,
  PropStack,
  TitleText,
} from './styles'

import { ValuePropsList } from './constants'
import { ValueProp } from './types'

import * as t from './strings'

type Props = {
  valueProps?: ValueProp[]
  isInline?: boolean
  mainTitle?: string
  maxNumToRender?: number
}

const PropList = (valueProps: ValueProp[], maxNumToRender: number) => {
  return valueProps.slice(0, maxNumToRender).map(data => {
    return (
      <div key={`${data.title}${data.description}`}>
        <div>{data.image}</div>
        <TitleText tag="h2">{data.title}</TitleText>
        <DescriptionText tag="p">{data.description}</DescriptionText>
      </div>
    )
  })
}

/**
 *
 * @param valueProps The list of value propositions to pass in
 * If left blank, will use props defined in constants
 * @param isInline If true, use InlineChildren to stack horizontally
 * Will default to false and use StackChildren if left empty
 */
export const ValueProps: React.FunctionComponent<Props> = ({
  valueProps = ValuePropsList,
  isInline = false,
  mainTitle = t.default.mainTitle(),
  maxNumToRender = Number.MAX_SAFE_INTEGER,
}) => {
  return (
    <React.Fragment>
      <MainTitleText>{mainTitle}</MainTitleText>
      {isInline && (
        <PropInline>{PropList(valueProps, maxNumToRender)}</PropInline>
      )}
      {!isInline && (
        <PropStack>{PropList(valueProps, maxNumToRender)}</PropStack>
      )}
    </React.Fragment>
  )
}

export default ValueProps
